import { useQuery } from "@tanstack/react-query";
import { FlameIcon, SpinnerGapIcon } from "@phosphor-icons/react";
import { fetchTrendingOrganic } from "../lib/api";
import { CoinTable } from "./CoinTable";
import { filterByAge, ageLabel } from "./AgeFilter";
import { useGlobalAge } from "../context/AgeFilterContext";

export const TrendingOrganic = () => {
  const { age } = useGlobalAge();
  const { data, isLoading } = useQuery({
    queryKey: ["trendingOrganic"],
    queryFn: fetchTrendingOrganic,
    refetchInterval: 120000,
    placeholderData: (p) => p,
  });
  const allCoins = data?.coins || [];
  const coins = filterByAge(allCoins, age);

  return (
    <div className="space-y-3 border-t border-white/10 pt-8" data-testid="trending-organic">
      <div className="flex items-center gap-2.5">
        <FlameIcon size={24} weight="fill" className="text-[#FF7A00]" />
        <h2 className="font-heading font-black text-2xl sm:text-3xl tracking-tighter leading-none">
          TRENDING <span className="text-[#FF7A00]">ORGANIC</span>
        </h2>
      </div>
      <p className="text-sm text-muted-foreground max-w-2xl">
        The coins Solana is actually trading right now — GeckoTerminal's live trending pools, ranked by real 1h
        volume, <span className="text-[#FF7A00] font-semibold">not paid boosts</span>. This is the closest thing to
        an Axiom-style Discover feed. Always DYOR.
      </p>
      {isLoading ? (
        <div className="flex justify-center py-14"><SpinnerGapIcon size={28} className="animate-spin text-[#FF7A00]" /></div>
      ) : allCoins.length === 0 ? (
        <div className="border border-white/10 bg-card py-14 text-center text-muted-foreground font-mono text-sm">
          Trending feed is quiet — check back soon.
        </div>
      ) : coins.length === 0 ? (
        <div className="border border-white/10 bg-card py-14 text-center text-muted-foreground font-mono text-sm">
          No trending coins under {ageLabel(age)} old right now — widen the age filter at the top.
        </div>
      ) : (
        <>
          <div className="text-xs font-mono text-muted-foreground">{coins.length} organically trending 🔥</div>
          <CoinTable coins={coins} sort="score" order="desc" onSort={() => {}} />
        </>
      )}
    </div>
  );
};
